import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../DependencyHelper";
import formStyles from "../CheckoutForms.module.scss";
import styles from "./PersonDetails.module.scss";
import { africaCountryCode } from "../../../../utils/helperServices";

const PersonDetails = ({
  formName,
  applicationType,
  variant,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  readOnlyValues,
  onChangeHandler,
  onBlurHandler,
  className,
  isGuestUser,
  formInfo,
}) => {
  const handleChange = (event) => {
    onChangeHandler(event, null, formName);
  };

  const handleBlur = (event) => {
    onBlurHandler(event, null, formName);
  };

  return (
    <CustomContainer
      className={`${formStyles[variant]} ${formStyles["main-container"]} ${className}`}
    >
      {formInfo && (
        <CustomContainer className={styles["form-info"]}>
          <img className={styles["icon"]} src={formInfo?.icon} />
          <span
            id={`form-info-${variant}-${formName}-desc`}
            className={styles["desc"]}
          >
            {formInfo?.desc}
          </span>
        </CustomContainer>
      )}
      <Form.Row className={formStyles["main-row"]}>
        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
          controlId={`validationFormpd101-${variant}-${formName}`}
        >
          <Form.Label
            className={formStyles["form-label"]}
            id={`validationFormpd101-label-${variant}-${formName}`}
          >
            First name
          </Form.Label>
          <Form.Control
            type="text"
            name="firstName"
            value={fieldValues["firstName"]}
            placeholder="Add your first name"
            onChange={handleChange}
            onBlur={handleBlur}
            readOnly={readOnlyValues["firstName"]}
            isInvalid={fieldErrors["firstName"]}
            className={fieldErrors["firstName"] ? formStyles["invalid"] : ""}
          />
          <Form.Control.Feedback
            type="invalid"
            className={formStyles["invalid-feedback"]}
          >
            {fieldErrorsMessage["firstName"]}
          </Form.Control.Feedback>
          {formName == "details" && !fieldErrors["firstName"] && (
            <div className={formStyles["hint-text"]}>
              {"As it appears on your ID / passport"}
            </div>
          )}
        </Form.Group>

        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
          controlId={`validationFormpd102-${variant}-${formName}`}
        >
          <Form.Label
            className={formStyles["form-label"]}
            id={`validationFormpd102-label-${variant}-${formName}`}
          >
            Surname
          </Form.Label>
          <Form.Control
            type="text"
            name="surName"
            value={fieldValues["surName"]}
            placeholder="Add your surname"
            onChange={handleChange}
            onBlur={handleBlur}
            readOnly={readOnlyValues["surName"]}
            isInvalid={fieldErrors["surName"]}
            className={fieldErrors["surName"] ? formStyles["invalid"] : ""}
          />
          <Form.Control.Feedback
            type="invalid"
            className={formStyles["invalid-feedback"]}
          >
            {fieldErrorsMessage["surName"]}
          </Form.Control.Feedback>
          {formName == "details" && !fieldErrors["surName"] && (
            <div className={formStyles["hint-text"]}>
              {"As it appears on your ID / passport"}
            </div>
          )}
        </Form.Group>
        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
          controlId={`validationFormpd103-${variant}-${formName}`}
        >
          <Form.Label
            className={formStyles["form-label"]}
            id={`validationFormpd103-label-${variant}-${formName}`}
          >
            Cellphone number
          </Form.Label>
          <Form.Control
            type="text"
            maxLength={
              africaCountryCode(fieldValues["cellNumber"]) ? "11" : "10"
            }
            name="cellNumber"
            value={fieldValues["cellNumber"]}
            placeholder="Add your cellphone number"
            onChange={handleChange}
            onBlur={handleBlur}
            readOnly={readOnlyValues["cellNumber"]}
            isInvalid={fieldErrors["cellNumber"]}
            className={fieldErrors["cellNumber"] ? formStyles["invalid"] : ""}
          />
          <Form.Control.Feedback
            type="invalid"
            className={formStyles["invalid-feedback"]}
          >
            {fieldErrorsMessage["cellNumber"]}
          </Form.Control.Feedback>
        </Form.Group>
        {formName == "details" && (
          <>
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
              controlId={`validationFormpd104-${variant}-${formName}`}
            >
              <Form.Label
                className={formStyles["form-label"]}
                id={`validationFormpd104-label-${variant}-${formName}`}
              >
                Email address
              </Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={fieldValues["email"]}
                placeholder="Add your email address"
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={readOnlyValues["email"]}
                isInvalid={fieldErrors["email"]}
                className={fieldErrors["email"] ? formStyles["invalid"] : ""}
              />
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {fieldErrorsMessage["email"]}
              </Form.Control.Feedback>
            </Form.Group>
            {!isGuestUser && applicationType == "normal" && (
              <Form.Group
                as={Col}
                sm="12"
                md="12"
                className={`${formStyles["form-group"]} ${styles["contact-check"]}`}
              >
                <Form.Check
                  custom
                  name="contactCheck"
                  label="I am the contact person for this address"
                  checked={fieldValues["contactCheck"]}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={formStyles["form-checkbox-label"]}
                  id={`validationFormpd105-${variant}-${formName}`}
                />
              </Form.Group>
            )}
          </>
        )}
      </Form.Row>
    </CustomContainer>
  );
};

PersonDetails.propTypes = {
  variant: PropTypes.oneOf(["plain", "popup"]),
  formName: PropTypes.oneOf(["details", "contactDetails"]),
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  readOnlyValues: PropTypes.object,
  onChangeHandler: PropTypes.func,
  className: PropTypes.string,
  isGuestUser: PropTypes.bool,
  applicationType: PropTypes.string,
  onBlurHandler: PropTypes.func,
};

PersonDetails.defaultProps = {
  variant: "plain",
  formName: "details",
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {},
  isGuestUser: false,
  applicationType: "normal",
  formInfo: null,
};

export default PersonDetails;
